import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { User } from "@/lib/types/userTypes"; 
import { useAdminUsers } from '@/hooks/useAdminUsers';

interface AdminUsersTableProps {
  users: User[];
}

export const AdminUsersTable = ({ users }: AdminUsersTableProps) => {
  const { updateUserRole } = useAdminUsers();

  const handleRoleChange = (id: number, role: string) => {
    updateUserRole.mutate({ id, role });
  };

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Name</TableHead>
          <TableHead>Email</TableHead>
          <TableHead>Role</TableHead>
          <TableHead>Actions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {users.map((user) => (
          <TableRow key={user.id}>
            <TableCell>{user.name}</TableCell>
            <TableCell>{user.email}</TableCell>
            <TableCell>{user.role}</TableCell>
            <TableCell>
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <Button variant="outline">Change Role</Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent>
                  <DropdownMenuItem onSelect={() => handleRoleChange(user.id, 'user')}>
                    User
                  </DropdownMenuItem>
                  <DropdownMenuItem onSelect={() => handleRoleChange(user.id, 'agent')}>
                    Agent
                  </DropdownMenuItem>
                  <DropdownMenuItem onSelect={() => handleRoleChange(user.id, 'admin')}>
                    Admin
                  </DropdownMenuItem>
                  <DropdownMenuItem
                    onSelect={() => handleRoleChange(user.id, 'superadmin')}
                  >
                    Superadmin
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
